import Swiper from 'swiper/bundle';

const swiperContainer = ".links-slider.swiper-container";

if($(swiperContainer).length > 0) {
    let swiperLinks = new Swiper(swiperContainer, {
        slidesPerView: 2,
        loop: false,
        spaceBetween: 8,
        slidesPerGroup: 2,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        breakpoints: {
            320: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            1024: {
                slidesPerGroup: 1,
                slidesPerView: 4,
                spaceBetween: 0,
            }
        }
    });
}

$(document).ready(function() {
    // Function to remove specified parameters from the URL
    function removeUrlParams(url, paramsToRemove) {
        let urlObj = new URL(url);
        paramsToRemove.forEach(param => {
            urlObj.searchParams.delete(param);
        });
        return urlObj.toString();
    }

    // Get the current URL
    let currentUrl = window.location.href;
    let paramsToRemove = ['email', 'firstname'];

    // Check if any specified parameters exist, then update the URL without reloading
    if (paramsToRemove.some(param => new URLSearchParams(window.location.search).has(param))) {
        let newUrl = removeUrlParams(currentUrl, paramsToRemove);
        window.history.replaceState(null, '', newUrl);
    }
});